import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import DatePicker from 'react-datepicker';
import { datePopperConfig } from "../Shared/datePopperConfig.js";
import MultiSelectField from "../Shared/MultiSelectField.js";
import AddItemCustomFields from "../Shared/AddItemCustomFields.js";
import ProductTreeSelector from "../Certificates/ProductTreeSelector.js";


const AddCertificateAndRegistrations = ({ globalContext, defaultCountry = null }) => {

    const [addProductIds, setAddProductIds] = useState(null);
    const [addCountry, setAddCountry] = useState(defaultCountry);
    const [addCertificate, setAddCertificate] = useState(null);
    const [addIssued, setAddIssued] = useState(null);
    const [addRiskClass, setAddRiskClass] = useState(null);
    const [addRegistrationStatus, setAddRegistrationStatus] = useState(null);
    const [addSelling, setAddSelling] = useState(null);
    const [addAssigned, setAddAssigned] = useState(null);
    const [addPriority, setAddPriority] = useState(null);
    const [addExpiryDate, setAddExpiryDate] = useState(null);

    const [errorAddCertificate, setErrorAddCertificate] = useState(false);
    const [errorAddCountry, setErrorAddCountry] = useState(false);
    const [errorAddIssued, setErrorAddIssued] = useState(false);
    const [errorAddRiskClass, setErrorAddRiskClass] = useState(false);
    const [errorAddRegistrationStatus, setErrorAddRegistrationStatus] = useState(false);
    const [errorAddSelling, setErrorAddSelling] = useState(false);
    const [errorAddAssigned, setErrorAddAssigned] = useState(false);
    const [errorAddPriority, setErrorAddPriority] = useState(false);
    const [errorAddExpiryDate, setErrorAddExpiryDate] = useState(false);

    const [errorAddingItem, setErrorAddingItem] = useState(null);

    const [isAddingItem, setIsAddingItem] = useState(false);
    const [addedSuccess, setAddedSuccess] = useState(false);
    const [fieldsConfig, setFieldsConfig] = useState([]); // Facets
    const [formState, setFormState] = useState({});
    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);


    const [countries, setCountries] = useState([]);

    const [field_DISTRIBUTORS, setField_DISTRIBUTORS] = useState({});
    const [fieldConfig_DISTRIBUTORS, setFieldConfig_DISTRIBUTORS] = useState([]);
    const [formState_DISTRIBUTORS, setFormState_DISTRIBUTORS] = useState({});

    const [field_IMPORTERS, setField_IMPORTERS] = useState({});
    const [fieldConfig_IMPORTERS, setFieldConfig_IMPORTERS] = useState([]);
    const [formState_IMPORTERS, setFormState_IMPORTERS] = useState({});


    const [field_REPRESENTATIVES, setField_REPRESENTATIVES] = useState({});
    const [fieldConfig_REPRESENTATIVES, setFieldConfig_REPRESENTATIVES] = useState([]);
    const [formState_REPRESENTATIVES, setFormState_REPRESENTATIVES] = useState({});


    const dropdownRefs = useRef({});

    const AppContext = globalContext;





    // This method validates if the form field if filled, sets the error message to
    // true for that field and returns false meaning the field is not valid

    const validFormField = (field, errorFunc) => {
        if (field == "" || field == null) {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };



    const addItem = () => {

        let isValidForm = true;

        setErrorAddCertificate(false);
        setErrorAddCountry(false);
        setErrorAddingItem(null);
        setAddedSuccess(false);

        if (!validFormField(addCertificate, setErrorAddCertificate))
            isValidForm = false;
        if (!validFormField(addCountry, setErrorAddCountry))
            isValidForm = false;
        if (!validFormField(addRiskClass, setErrorAddRiskClass))
            isValidForm = false;
        if (!validFormField(addSelling, setErrorAddSelling))
            isValidForm = false;
        if (!validFormField(addRegistrationStatus, setErrorAddRegistrationStatus))
            isValidForm = false;
        if (!validFormField(addPriority, setErrorAddPriority))
            isValidForm = false;

        if (!isValidForm) {
            setErrorAddingItem("Certificate, Country, Risk Class, Selling, Status and Priority can't be empty");
            return false;
        }


        let isSelling = addSelling ? addSelling : true;


        let newItem = {
            ProductIds: addProductIds,
            RiskClass: addRiskClass,
            Status: addRegistrationStatus,
            IssuedBy: addIssued,
            CountryId: addCountry,
            Name: addCertificate,
            ExpiryDate: addExpiryDate,
            Selling: isSelling,
            AssignedTo: addAssigned ? [parseInt(addAssigned)] : null,
            Priority: addPriority,
            ImportersIds: formState_IMPORTERS["importers"],
            CountryRepresentativesIds: formState_REPRESENTATIVES["representatives"],
            CountryDistributorsIds: formState_DISTRIBUTORS["distributors"],
            CustomFieldsAnswers: [] //AppContext.newItemCustomFieldsAnswers,
        };



        setIsAddingItem(true);

        let dataUrl = "/umbraco/api/RIMSRegistrations/Certificates/";

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };




        fetch(dataUrl, requestOptions)
            .then(async (response) => {
                if (!response.ok) {

                    let message = await response.text();

                    if (response.status == 400)
                        throw new Error(message);

                    throw new Error("Unexpected error, refresh and try again");
                }

                return response.json();
            })
            .then((item) => {

                // Refresh registrations list
                AppContext.refreshData();

                setAddedSuccess(true);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setErrorAddingItem(error.message);
            })
            .finally(() => {
                setIsAddingItem(false);
            });


    }



    const loadOperators = (preserveSelection = false) => {

        let url = "/umbraco/api/ProductRegistrationsApi/OperatorsGroupedByRole";

        let requestOptions = {};

        return fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Importers

                let importers = { Alias: "importers", Name: "Importers", Items: [] };

                importers.Items = data.importers.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_IMPORTERS(importers);
                setFieldConfig_IMPORTERS([importers]);
                if (!preserveSelection)
                    setFormState_IMPORTERS({ importers: [] });

                // Representatives

                let representatives = { Alias: "representatives", Name: "Representatives", Items: [] };

                representatives.Items = data.representatives.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_REPRESENTATIVES(representatives);
                setFieldConfig_REPRESENTATIVES([representatives]);
                if (!preserveSelection)
                    setFormState_REPRESENTATIVES({ representatives: [] });


                // Distributors

                let distributors = { Alias: "distributors", Name: "Distributors", Items: [] };

                distributors.Items = data.distributors.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_DISTRIBUTORS(distributors);
                setFieldConfig_DISTRIBUTORS([distributors]);
                if (!preserveSelection)
                    setFormState_DISTRIBUTORS({ distributors: [] });


            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });

    }



    const loadCountries = () => {

        let url = "/umbraco/api/RIMSProducts/Countries";

        let requestOptions = {};

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let countries = data.map(country => ({ id: country.CountryId, name: country.CountryName }));

                countries.sort((a, b) => a.name.localeCompare(b.name));

                let NA = { id: 0, name: "N/A" };

                countries = [NA, ...countries];

                setCountries(countries);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });
    }



    useEffect(() => {

        // Operators

        loadOperators();

        loadCountries();


    }, []);




    const riskClassList = [
        { Id: "", Name: "Choose an option" },
        { Id: 0, Name: "I" },
        { Id: 1, Name: "Is" },
        { Id: 2, Name: "Im" },
        { Id: 3, Name: "II" },
        { Id: 4, Name: "IIa" },
        { Id: 5, Name: "IIb" },
        { Id: 6, Name: "III" },
        { Id: 7, Name: "IV" },
        { Id: 8, Name: "A" },
        { Id: 9, Name: "B" },
        { Id: 10, Name: "C" },
        { Id: 11, Name: "D" },
        { Id: 12, Name: "Unclassified" },
        { Id: 13, Name: "Other" },
    ];



    const registrationStatusList = [
        { Id: "", Name: "Choose an option", className: "g-bg-blue" },
        { Id: 7, Name: "Pre-Market Assessment", className: "g-bg-blue" },
        { Id: 0, Name: "New Registration Ongoing", className: "g-bg-blue" },
        { Id: 6, Name: "Registration Not Required", className: "g-bg-gray-light-v1" },
        { Id: 1, Name: "Active", className: "g-bg-green" },
        { Id: 3, Name: "Active - Renewing", className: "g-bg-green" },
        { Id: 4, Name: "Active - Modification", className: "g-bg-green" },
        { Id: 5, Name: "Suspended", className: "g-bg-lightred" },
        { Id: 2, Name: "Expired", className: "g-bg-lightred" },
        { Id: 8, Name: "Discontinued", className: "g-bg-black" },
        { Id: 9, Name: "Not Registered", className: "g-bg-orange" },
    ];



    const yesNoList = [
        { Id: "", Name: "Choose an option" },
        { Id: "true", Name: "Yes" },
        { Id: "false", Name: "No" },
    ];


    const renewalPriorityList = [
        { Id: "", Name: "Choose an option" },
        { Id: 0, Name: "None" },
        { Id: 1, Name: "Low" },
        { Id: 2, Name: "Medium" },
        { Id: 3, Name: "High" },
    ];



    return (
        <>
            
            <div style={{ paddingTop: "10px", textAlign: "left" }}>


                        <div style={{ display: "flex", flexDirection: "row" }}>

                            <div style={{ flex: 1 }}>

                                <div style={{ width: "100%" }}>
                                    Certificate *
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddCertificate ? " form-field-error" : null}`}
                                        value={addCertificate}
                                        onChange={(e) => setAddCertificate(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddCertificate && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />





                                <SearchableCountrySelect
                                    label="Country *"
                                    value={addCountry}
                                    onChange={setAddCountry}
                                    countries={countries}
                                />

                                {errorAddCountry && (
                                    <>
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                        <br/>
                                    </>
                                )}

                                <br />



                                <div style={{ width: "100%" }}>
                                    Registration issued by (Organization)
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddIssued ? " form-field-error" : null}`}
                                        value={addIssued}
                                        onChange={(e) => setAddIssued(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddIssued && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />



                                {/* Importers */}


                                <div style={{ width: "100%" }}>

                                    <MultiSelectField
                                        field={field_IMPORTERS}
                                        formState={formState_IMPORTERS}
                                        setFormState={setFormState_IMPORTERS}
                                        fieldsConfig={fieldConfig_IMPORTERS}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                        allowAddOperator={true}
                                        operatorRoleId={2}
                                        onRefreshOperators={() => loadOperators(true)}
                                    />

                                </div>

                                <br />



                                {/* Representative */}

                                <div style={{ width: "100%" }}>

                                    <MultiSelectField
                                        field={field_REPRESENTATIVES}
                                        formState={formState_REPRESENTATIVES}
                                        setFormState={setFormState_REPRESENTATIVES}
                                        fieldsConfig={fieldConfig_REPRESENTATIVES}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                        allowAddOperator={true}
                                        operatorRoleId={3}
                                        onRefreshOperators={() => loadOperators(true)}
                                    />

                                </div>

                                <br />




                                {/* Distributors */}

                                <div style={{ width: "100%" }}>

                                    <MultiSelectField
                                        field={field_DISTRIBUTORS}
                                        formState={formState_DISTRIBUTORS}
                                        setFormState={setFormState_DISTRIBUTORS}
                                        fieldsConfig={fieldConfig_DISTRIBUTORS}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                        allowAddOperator={true}
                                        operatorRoleId={4}
                                        onRefreshOperators={() => loadOperators(true)}
                                    />

                                </div>

                                <br />




                                <div style={{ width: "100%" }}>
                                    Risk Class *
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddRiskClass ? "form-field-error" : ""
                                            }`}
                                        value={addRiskClass}
                                        onChange={(e) => setAddRiskClass(e.target.value)}
                                        style={{ width: "100%" }}
                                    >
                                        {riskClassList.map((item) => (
                                            <option key={item.Id} value={item.Id}>
                                                {item.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddRiskClass && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />



                                <div style={{ width: "100%" }}>
                                    Registration Status *
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddRegistrationStatus ? "form-field-error" : ""
                                            }`}
                                        value={addRegistrationStatus}
                                        onChange={(e) => setAddRegistrationStatus(e.target.value)}
                                        style={{ width: "100%" }}
                                    >

                                        {registrationStatusList.map((item) => (
                                            <option key={item.Id} value={item.Id}>
                                                {item.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddRegistrationStatus && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />




                                <div style={{ width: "100%" }}>
                                    Selling *
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddSelling ? "form-field-error" : ""
                                            }`}
                                        value={addSelling}
                                        onChange={(e) => setAddSelling(e.target.value.toString())}
                                        style={{ width: "100%" }}
                                    >

                                        {yesNoList.map((item) => (
                                            <option key={item.Id.toString()} value={item.Id.toString()}>
                                                {item.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddSelling && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />


                                <div style={{ width: "100%" }}>
                                    Assigned User
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddAssigned ? "form-field-error" : ""
                                            }`}
                                        value={addAssigned}
                                        onChange={(e) => setAddAssigned(e.target.value)}
                                        style={{ width: "100%" }}
                                    >
                                        <option value="">Select User</option>

                                        {AppContext.users.map((user) => (
                                            <option key={user.Id} value={user.Id}>
                                                {user.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddAssigned && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />





                                <div style={{ width: "100%" }}>
                                    Renewal Priority *
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddPriority ? "form-field-error" : ""
                                            }`}
                                        value={addPriority}
                                        onChange={(e) => setAddPriority(e.target.value)}
                                        style={{ width: "100%" }}
                                    >

                                        {renewalPriorityList.map((item) => (
                                            <option key={item.Id} value={item.Id}>
                                                {item.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddPriority && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />

                                <div style={{ width: "100%" }}>
                                    Expiry Date
                                    <br />

                                    <input
                                        className={`form-field-text add-task-field-name ${errorAddExpiryDate ? "form-field-error" : ""
                                            }`}
                                        value={addExpiryDate}
                                        onChange={(e) => setAddExpiryDate(e.target.value)}
                                        style={{ width: "100%" }}
                                        type="date"
                                    />

                                    {errorAddExpiryDate && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />










                                <br />

                            </div>



                            {/* TREE */}
                            {/* TREE */}
                            {/* TREE */}

                            <div style={{ flex: 1, marginLeft: "100px" }}>

                                <ProductTreeSelector onSelectionChange={setAddProductIds} />

                            </div>



                        </div>

                        {/* BUTTONS */}

                        <div className="action-button-bar">

                            <div className="action-button-bar-left">
                                
                            </div>

                            <div className="action-button-bar-center">

                                {errorAddingItem ?
                                    <div
                                        style={{
                                            padding: "10px",
                                            borderRadius: "6px",
                                            background: "#ffe5e5",
                                            color: "#b30000",
                                            fontSize: "0.9rem"
                                        }}
                                    >
                                        Error: {errorAddingItem}
                                    </div>
                                : null}



                                {addedSuccess ? 
                                    <div
                                        style={{
                                            padding: "10px",
                                            borderRadius: "6px",
                                            background: "#e6ffed",
                                            color: "#1a7f37",
                                            fontSize: "0.9rem"
                                        }}
                                    >
                                        Certificate added successfully!
                                    </div>
                                : null}


                            </div>

                            <div className="action-button-bar-right">
                                {isAddingItem ? (
                                    <LoadingSpinnerImage />
                                ) : (
                                    <button
                                        className="action-button save-button"
                                        onClick={addItem}
                                    >
                                        Add Certificate
                                    </button>
                                )}
                            </div>
                        </div>



                    </div>


        </>
    );
};





const SearchableCountrySelect = ({
    label,
    value,
    onChange,
    countries
}) => {

    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");

    const selected = countries.find(c => c.id == value);

    const filtered = countries.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div style={{ width: "100%", position: "relative" }}>
            {label}
            <br />

            <input
                type="text"
                value={isOpen ? search : (selected?.name || "")}
                placeholder="Search country..."
                onFocus={() => {
                    setIsOpen(true);
                    setSearch("");
                }}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setIsOpen(true);
                }}
                onBlur={() => {
                    setTimeout(() => setIsOpen(false), 150);
                }}
                style={{
                    width: "100%",
                    padding: "6px",
                    border: "1px solid #ccc",
                    borderRadius: "4px"
                }}
            />

            {isOpen && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "200px",
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        zIndex: 1000
                    }}
                >
                    {filtered.length > 0 ? (
                        filtered.map(country => (
                            <div
                                key={country.id}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                    onChange(country.id);
                                    setIsOpen(false);
                                    setSearch(country.name);
                                }}
                                style={{
                                    padding: "6px",
                                    cursor: "pointer"
                                }}
                            >
                                {country.name}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: "6px", color: "#888" }}>
                            No results
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};


export default AddCertificateAndRegistrations;